/*
 * サブシステム名：マスタ管理
 * 機能名：お知らせメンテナンス
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdListHeader from '@/components/DdListHeader'
import DdQuillEditor from '@/components/DdQuillEditor'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2MSTT0470.js'

import date from '@/ddv2.library/date'
import indexeddb from '@/ddv2.library/indexeddb'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'
import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'

const DdDateBox = () => import('@/components/DdDateBox')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdTextBox = () => import('@/components/DdTextBox')

const SYSTEM_MESSAGE = '10'
const IMPORTAMT = '10'

export default {
  name: 'MstMenuOshiraseListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdTransparentButton,
    DdListHeader,
    DdQuillEditor,
    DdDateBox,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    itemsPerPage: 25,
    page: 1,
    isCreateButtonDisp: false,
    isCsvDownloader: false,
    modalId: 0,
    modalFlg: false,
    oshiraseKbn: null,
    effectiveOnlyFlg: true,
    // 編集用
    rec: {},
    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      jininLIst: 'DDMasters/mstJinin',
      kubunList: 'DDMasters/msysKubun',
      currentKaishaCode: 'users/currentKaishaCode',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRows () {
      const target = date.getCurrentDate()
      const self = this
      return this.rows.map((elem) => {
        var kbnm01 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM01', elem.title)
        var kbnm00 = indexeddb.getKubun(self.currentKaishaCode, self.kubunList, 'KBNM00', elem.hasseimotoKbn)
        var insUser = indexeddb.getRecord(self.jininLIst, elem.insUserId)
        var updUser = indexeddb.getRecord(self.jininLIst, elem.insUserId)

        elem.oshiraseSbtNm = kbnm01 ? kbnm01.codeNm : ''
        elem.oshiraseSbtColor = kbnm01 ? kbnm01.komoku1 : 'white'
        elem.hasseimotoKbnNm = kbnm00 ? kbnm00.codeNm : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        elem.insUserNm = insUser ? insUser.jininNmSei : ''
        elem.updUserNm = updUser ? updUser.jininNmSei : ''
        return elem
      }).filter(function (elem) {
        var rtnCd = true
        if (self.effectiveOnlyFlg) {
          if (elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target) {
          } else {
            rtnCd = false
          }
          if ([undefined, null].includes(self.oshiraseKbn)) {
          } else {
            if (elem.hasseimotoKbn !== self.oshiraseKbn) { rtnCd = false }
          }
        }
        return rtnCd && elem.delFlg === false
      }).sort((elem1, elem2) => {
        if (elem1.hasseimotoKbn > elem2.hasseimotoKbn) { return 1 }
        if (elem1.hasseimotoKbn === elem2.hasseimotoKbn) { return 0 }
        return -1
      })
    },
    filteredHasseimotoKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBNM00')
    },
    filteredTitleList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBNM01')
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isShowCreateButton () {
      return this.isCreateButtonDisp
    }
  },
  created () {
  },
  mounted () {
    console.log('MstMenuOshiraseListEdit')
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstjinin', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.headers = [
              // { text: 'No', value: 'id' },
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: 'カテゴリ', value: 'hasseimotoKbnNm' },
              { text: '種別', value: 'oshiraseSbtNm', align: 'center' },
              { text: 'お知らせ内容', value: 'oshiraseShosai' },
              { text: '表示開始年月日', value: 'tekiyoStartYmdDisp' },
              { text: '表示終了年月日', value: 'tekiyoEndYmdDisp' },
              { text: '登録者', value: 'insUserNm' },
              { text: '更新者', value: 'updUserNm' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hacchakuchiCd: '',
              hacchakuchiNm: '',
              torihikisakiCd: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            self.isCreateButtonDisp = kengen.kengenValue !== 50

            self.onSearchButtonClick()
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.rows = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.get('/api/v1/MsysMenuOshirase/GetAll', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    onEditCloseButtonClick: function (e) {
      this.$modal.hide('edit-dialog')
    },
    onRowDoubleClick: function (e, f) {
      this.onEditOpenButtonClick(f.item)
    },
    onRowEditButtonClick: function (item) {
      this.onEditOpenButtonClick(item)
    },
    onEditOpenButtonClick: function (e) {
      const tmp = {
        id: e ? e.id : 0,
        kaishaCd: e ? e.kaishaCd : this.currentKaishaCode,
        tekiyoStartYmdString: e ? e.tekiyoStartYmdDisp : date.getCurrentDate(),
        tekiyoEndYmdString: e ? e.tekiyoEndYmdDisp : this.getAfter14DaysfromToday(),
        title: e ? e.title : IMPORTAMT,
        oshiraseShosai: e ? e.oshiraseShosai : '',
        hasseimotoKbn: e ? e.hasseimotoKbn : null,
        linkUrl: e ? e.linkUrl : '',
        updDate: e ? e.updDate : date.getCurrentDate()
      }
      this.rec = Object.assign({}, tmp)
      this.$modal.show('edit-dialog')
    },
    searchValidate: function () {
      return true
    },
    onSaveButtonClick: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.rec.id = data.payload.id
            // 再検索
            self.$modal.hide('edit-dialog')
            self.onSearchButtonClick()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.rec.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.rec.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return true
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      // 日付項目再設定
      this.rec.infoYmd = this.rec.tekiyoStartYmdString
      this.rec.tekiyoStartYmd = this.rec.tekiyoStartYmdString
      this.rec.tekiyoEndYmd = this.rec.tekiyoEndYmdString
      // システムお知らせの場合に会社コードを上書き
      if (this.rec.hasseimotoKbn === SYSTEM_MESSAGE) this.rec.kaishaCd = '****'

      let f
      console.log('registerPromise', this.rec.id)
      if (this.rec.id === 0) {
        f = this.HttpClient.post('/api/v1/MsysMenuOshirase/Create', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/MsysMenuOshirase/Update?id=${this.rec.id}`, this.rec)
      }
      return f
    },
    // 入力チェック
    registerValidate: function () {
      var ret = true
      this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
      this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](undefined)
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.setInvalidSummaryMessage('COME0014')
        ret = false
      }
      return ret
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      this.vitemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.vPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // 日付操作
    getAfter14DaysfromToday: function () {
      var date = new Date()
      date.setDate(date.getDate() + 14)
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)

      return Y + '/' + M + '/' + D
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
